<template>
    <div v-if="isLoginPage" class="layout--full-page">
      <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
          <vx-card>
            <div slot="no-body" class="full-page-bg-color">
  
              <div class="vx-row no-gutter justify-center items-center">
  
                <div class="vx-col hidden lg:block lg:w-1/2">
                  <img src="@/assets/images/research.png" alt="login" class="mx-auto">
                </div>
  
                <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                  <div class="p-8 login-tabs-container">
  
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4">Đăng nhập báo cáo</h4>
                      <p>hpquet phiên bản mới - hp@2020.</p>
                    </div>
  
                    <form v-on:submit.prevent="preventSubmit()">
                      <vs-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                        label-placeholder="Mật khẩu" v-model="password" class="w-full mt-6" />
  
                      <div class="flex flex-wrap justify-between my-5">
                        <vs-alert :active="loginError" color="danger" icon="new_releases">
                          <span>Sai thông tin đăng nhập</span>
                        </vs-alert>
                      </div>
  
                      <vs-button button="submit" class="float-right mb-5" @click="login">Đăng nhập</vs-button>
                    </form>
  
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  
    <div v-else>
  
      <div class="relative">
        <div class="vx-navbar-wrapper navbar-full p-0">
          <vs-navbar class="navbar-custom navbar-skelton">
            <div class="the-navbar__user-meta flex items-center">
              <img style="width:20%; margin-right: 50px;" :src="require('@/assets/logo.png')" />
              <div class="leading-tight hidden sm:block">
                <p class="font-semibold">BÁO CÁO</p><small>Bản Quyền Thuộc Về HPQuet</small>
              </div>
  
            </div>
          </vs-navbar>
        </div>
      </div>
  
      <vx-card ref="filterCard" class="mb-1">
        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12"
            class="hidden sm:block" style="line-height: 1.8; margin-left: 10%">
            <span>Phân tích: {{cheat}}</span> <br />
            <span>Ngày: {{date}}</span><br />
            <span>Tài khoản: {{member_name}}</span><br />
            <span class="text-primary" style="font-size: 1.3rem;">Kết luận: {{reason}}</span>
          </vs-col>
        </vs-row>
      </vx-card>
  
      <div class="vx-card">
        <vs-table stripe :data="cheatDetail" style="padding: 10px;">
          <template slot="thead">
            <vs-th :key="h.id" v-for="h in header">
              {{ h.title }}
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :class="data[indextr - 1] && data[indextr - 1].key != data[indextr].key ? 'bet_key_border' : null"
              :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :key="h.id" v-for="h in header" :data="data[indextr][h.field]">
                <p
                  :class="tr.bet_key && h.field == 'member_name' ? 'bet_key' : tr.dup && h.field == 'member_name' ? 'bet_dup' : null">
                  <template v-if="h.render">
                    {{ h.render(data[indextr]) }}
                  </template>
                  <template v-else>
                    {{ data[indextr][h.field] }}
                  </template>
                </p>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </template>
  
  
  <style lang="css">
    .con-tab.vs-tabs--content {
      padding: 1px;
    }
  
    .con-vs-chip {
      top: 0px;
      border-radius: 20px;
      color: #000;
      min-height: 20px;
      min-width: 20px;
    }
  
    .bet_key_border {
      border-top: 10px solid #ddd;
    }
  
    .bet_key {
      color: rgb(255 0 22);
      /* color: #f02849; */
    }
  
    .bet_dup {
      color: rgb(0 97 255);
      /* color: #216fdb; */
    }
  
    .vs-tabs--li button.vs-tabs--btn {
      padding: 7px;
    }
  
    .vs-button:disabled {
      opacity: 1;
    }
  </style>
  
  <script>
  
    import moment from "moment";
  
    export default {
      data() {
        return {
          password: "",
          datas: [],
          loginError: false,
          isLoginPage: true,
          header: [
            { title: "Tên thành viên", field: "member_name", render: function (data) { return data.member_name.toUpperCase(); } },
            { title: "Ngày", field: "bet_time", render: function (data) { return moment(data.bet_time).format("DD-MM-YYYY|HH:mm:ss") } },
            { title: "IP", field: "bet_ip" },
            { title: "Trận", field: "bet_match" },
            { title: "Loại", field: "bet_type" },
            { title: "Chọn", field: "bet_choice", render: function (data) { return `${data.bet_choice} ${data.bet_handicap} ${data.bet_favorite}` } },
            { title: "Odds", field: "bet_odds" },
            { title: "Stake", field: "bet_stake" },
            { title: "Status", field: "bet_status" },
            { title: "Sàn", field: "board_id", render: function (data) { return data.board_id == 1 ? "ibet" : data.board_id == 2 ? "sbobet" : "unknown"; } },
          ],
          cheatDetail: [],
          itemsPerPage: 1000,
          reason: "",
          date: "",
          member_name: "",
          cheat: ""
          // all: true,
          // filterOdds: 0
        }
      },
      watch: {
        currentUser: function (u) {
          this.$acl.change(u.permissions);
          this.$router.push({ name: 'home' });
        }
      },
      methods: {
        login() {
          let vm = this;
          vm.loginError = false;
          // Loading
          vm.$vs.loading();
  
          this.$http.get(`view-guest-report?password=${vm.password}`).then((res) => {
            vm.$vs.loading.close();
            console.log(res);
            if (res.data.code < 0) {
              vm.loginError = true;
            } else {
              vm.isLoginPage = false;
  
              vm.reason = res.data.data.reason;
              vm.date = res.data.data.date;
              vm.member_name = res.data.data.member_name;
              vm.cheat = res.data.data.cheat;
              let datas = res.data.data.data;
              let all = res.data.data.all;
              let filterOdds = res.data.data.filterOdds;

              vm.cheatDetail = all === 0 ? datas : datas.filter(bet => bet.dup);

              // vm.processData(data, all, filterOdds);
            }
          });
  
  
          //   vm.$store
          //     .dispatch('login', {
          //       name: vm.user,
          //       password: vm.password,
          //     })
          //     .then((res) => {
          //       vm.$vs.loading.close();
          //     })
          //     .catch(err => {
          //       vm.loginError = true;
          //       vm.$vs.loading.close();
          //     })
        },
        processData: function (data, all, filterOdds) {
          // if (!Array.isArray(data)) {
          //     console.error("Data is not an array.");
          //     return [];
          // }
  
          // this.cheatDetail = data.filter(bet => bet.dup);
  
          if (filterOdds === 0) {
            this.cheatDetail = all === 0 ? data : data.filter(bet => bet.dup);
          } else {
            this.cheatDetail = this.groupAndFilterData(data, filterOdds);
          }
        },
        groupAndFilterData: function (data, val) {
          if (!Array.isArray(data)) {
            console.error("Data is not an array.");
            return [];
          }
  
          const groupByKey = data.reduce((r, a) => {
            r[a.key] = r[a.key] || [];
            r[a.key].push(a);
            return r;
          }, {});
  
          let result = [];
  
          Object.values(groupByKey).forEach(gby => {
            const betKey = gby.find(obj => obj.bet_key === true);
            if (!betKey) return;
  
            const keyOdds = betKey.bet_odds;
  
            const tolerance = parseFloat("0.0" + (Number.isInteger(val) ? val : 5)); // Mặc định là 5 nếu val không hợp lệ
  
            const betValue = gby
              .filter(obj => obj.bet_key !== true && obj.bet_odds * keyOdds < 0)
              .filter(obj => {
                const ko = Math.abs(keyOdds);
                const vo = Math.abs(obj.bet_odds);
                return Math.abs(vo - ko).toFixed(2) <= tolerance;
              })
              .map(a => a.bet_odds);
  
            if (betValue.length > 0) {
              let odds = new Set();
              gby.forEach(obj => {
                if (obj.bet_key || (!odds.has(obj.bet_odds) && betValue.includes(obj.bet_odds))) {
                  result.push(obj);
                  odds.add(obj.bet_odds);
                }
              });
            }
          });
  
          return result;
        },
        preventSubmit: function () {
          return false;
        },
      }
    }
  </script>
  
  <style lang="scss">
    #page-login {
      .social-login-buttons {
        .bg-facebook {
          background-color: #1551b1
        }
  
        .bg-twitter {
          background-color: #00aaff
        }
  
        .bg-google {
          background-color: #4285F4
        }
  
        .bg-github {
          background-color: #333
        }
      }
    }
  </style>